<mat-select [formControl]="formControl">
  <mat-select-trigger>
    @if (selectedOption?.icon) {
      <mat-icon>
        {{ selectedOption?.icon }}
      </mat-icon>
      {{ selectedOption?.label }}
    }
  </mat-select-trigger>
  @for (opt of selectOptions$ | async; track opt.value) {
    <mat-option [value]="opt.value">
      @if (opt.icon) {
        <mat-icon>{{ opt.icon }}</mat-icon>
      }
      {{ opt.label }}
    </mat-option>
  }
</mat-select>
